export default "__VITE_ASSET__AOZFvGe___"